import { atom } from 'recoil';
import { IStatus } from '../../../commons/types/crm';

export const statusAtom = atom<IStatus[]>({
  key: 'status',
  default: [] as IStatus[],
});

